/**
 * @module Notification
 */
(function Notification() {

    /**
     * Handle visibility of notification
     * @method notification
     * @param NOTIFICATION
     */
    function notification(NOTIFICATION) {
        /**
         * @type {notification}
         * @method notification
         * @private
         */
        var _this = this;

        this.COOKIE_NAME = "juzo-notification";
        this.VISIBILITY_CLASS = "hidden";
        this.CTA_SELECTOR = ".js-cta";

        /**
         * Notification container
         * @type {HTMLElement}
         */
        this.notification = document.querySelector(NOTIFICATION);

        /**
         * toggle visibility class
         */
        this.toggleNotification = function () {
            _this.notification.classList.toggle(_this.VISIBILITY_CLASS);
        };

        /**
         * Check notification cookie is set
         * @returns {boolean}
         */
        this.isNotificationCookieSet = function () {
            const cookies = `; ${document.cookie}`;
            const parts = cookies.split(`; ${_this.COOKIE_NAME}=`);
            return parts.length === 2;
        }

        /**
         * Set specified system cookie for notification
         */
        this.setNotificationCookie = function () {
            document.cookie = `${_this.COOKIE_NAME}=true;;path=/`;
        }

        /**
         * Click event and visibility handling if notification are currently not accepted
         */
        this.bindNotificationVisibility = function () {
            _this.notification.querySelector(_this.CTA_SELECTOR).addEventListener('click', () => {
                _this.toggleNotification();
                _this.setNotificationCookie();
            });
        }

        /**
         * Handle notification if available and cookie based
         * currently disabled
         */
        if (!this.isNotificationCookieSet()) {
            _this.toggleNotification();
            _this.bindNotificationVisibility();
        }


    }

    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }

    window.Juzo.notification = notification;
})();

$(document).ready(function () {
    const NOTIFICATION_SELECTOR = ".js-notification"
    if (document.querySelectorAll(NOTIFICATION_SELECTOR).length) {
        window.Juzo.notification(NOTIFICATION_SELECTOR);
    }
});
